import useAsyncData from "../../../../hooks/use-async-data";
import contractsService from "../../contracts.service";
import ContractsCargoTaxiList from "./contracts-cargo-taxi-list";
import ContractsCargoTaxiListParams from "./contracts-cargo-taxi-list-params";

const useContractsCargoTaxiList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<ContractsCargoTaxiList>({ data: [], totalCount: 0 });

  const load = async (
    params: ContractsCargoTaxiListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const cargoTaxiContractList: ContractsCargoTaxiList =
        await contractsService.getCargoTaxiContractList(params, signal);

      setData(cargoTaxiContractList);
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useContractsCargoTaxiList;
